import { Injectable, signal } from '@angular/core';

export type AppFeedbackSeverity = 'success' | 'error';

export interface AppFeedbackMessage {
  id: number;
  severity: AppFeedbackSeverity;
  summary: string;
  detail: string;
}

@Injectable({ providedIn: 'root' })
export class AppFeedbackService {
  private nextId = 1;
  private readonly messageValue = signal<AppFeedbackMessage[]>([]);

  readonly messages = this.messageValue.asReadonly();

  success(detail: string, summary = 'Success'): void {
    this.add('success', summary, detail, 2600);
  }

  error(detail: string, summary = 'Request failed'): void {
    this.add('error', summary, detail, 5600);
  }

  dismiss(id: number): void {
    this.messageValue.update((messages) => messages.filter((message) => message.id !== id));
  }

  private add(severity: AppFeedbackSeverity, summary: string, detail: string, life: number): void {
    const message: AppFeedbackMessage = {
      id: this.nextId++,
      severity,
      summary,
      detail
    };

    this.messageValue.update((messages) => [...messages.slice(-3), message]);
    window.setTimeout(() => this.dismiss(message.id), life);
  }
}
